import { render, staticRenderFns } from "./EmployeesEdit.vue?vue&type=template&id=0872a47a&scoped=true&"
import script from "./EmployeesEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeesEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EmployeesEdit.vue?vue&type=style&index=1&id=0872a47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0872a47a",
  null
  
)

component.options.__file = "EmployeesEdit.vue"
export default component.exports